import React from 'react';
import { createStore, useStore } from 'zustand';

const openModalsCountStore = createStore<{
  openModalsCount: number;
  register: (isOpen: boolean) => () => void;
}>((set) => ({
  openModalsCount: 0,
  register: (isOpen: boolean) => {
    set((state) => ({
      openModalsCount: state.openModalsCount + (isOpen ? 1 : 0),
    }));
    return () =>
      set((state) => ({
        openModalsCount: state.openModalsCount - (isOpen ? 1 : 0),
      }));
  },
}));

export function useRegisterModal(isOpen: boolean = true) {
  const { register } = useStore(openModalsCountStore);
  React.useEffect(() => {
    return register(isOpen);
  }, [register, isOpen]);
}

export function useOpenModalsCount() {
  return useStore(openModalsCountStore);
}
